import TransferOrderController from './transferorder.controller';

/**
 * this is the controller to create a new transport order
 **/
export default class ArtikelUmbuchenController extends TransferOrderController {


	constructor($injector, $scope) {
		super($injector);
		this.$rootScope = $injector.get("$rootScope");
		this.$scope = $scope;
		this.$rootRouter = $injector.get("$rootRouter");
		this.TransferOrderService = $injector.get('TransferOrderService');
		this.LocationService = $injector.get('LocationService');
		this.$window = $injector.get('$window');
		this.innerWidth = this.$window.innerWidth;

		this.OrderService = $injector.get('OrderService');
		this.moment = $injector.get('moment');
		this.$mdpTimePicker = $injector.get('$mdpTimePicker');
		this.deactivateChangeListener = false;
        this.locations = this.$storage.locations;

		this.initView();
	}

	/**
	 * initialize the component and define some models
	 **/
	$onInit() {
		this.component = {
			title: 'Artikel umbuchen',
			icon: ''
		};
	}

	initView() {
        this.deactivateChangeListener = true;

        this.artikel = null;
        this.artikelNummer = '';
        this.artikelMenge = 0;

        this.gewaehlterQuellLagerOrt = null;
        this.gewaehlteCharge = null;

        this.suchTextLagerVon = '';
        this.suchTextCharge = '';

        this.gewaehlterZielLagerOrt = null;
        this.suchTextLagerZiel = '';


        if (typeof this.$scope.artikelUmbuchenForm !== 'undefined'){
            this.$scope.artikelUmbuchenForm.$setPristine();
            this.$scope.artikelUmbuchenForm.$setUntouched();
		}
        this.deactivateChangeListener = false;
    }

	fillViewWithArticleInfos(artikel){
        this.artikel = artikel;
	}

	/**
	 * the component is ready
	 **/
	$routerOnActivate(next, prev) {
		this.$rootScope.$broadcast('toolbar:updateTitle', this.component);
	}

    artikelInfosSuchen(artikelNummer) {
        this.TransferOrderService.ladeArtikelInfo(artikelNummer)
            .then((response) => {
            	this.fillViewWithArticleInfos(response);
            });
	}

    sucheQuellLager(suchTextLagerVon){
		let eindeutigeLagerorte = [];
		let gefundeneIds = [];
		let i;
		for(i = 0; i < this.artikel.lagerorte.length; i++){
			let lagerort = this.artikel.lagerorte[i];

			// nicht eindeutig - überspringen.
			if (gefundeneIds.indexOf(lagerort.lgrortId) !== -1){
				continue;
            }

			// entweder keine charge gewählt, dann einfach in die Auswahl aufnehmen
			// oder gewählte charge muss am lagerort vorliegen.
            if (
                !(this.gewaehlteCharge === null ||
                    typeof this.gewaehlteCharge === 'undefined' ||
                    typeof this.gewaehlteCharge.chargeSNrId === 'undefined' ||
                    this.gewaehlteCharge.chargeSNrId === lagerort.chargeSNrId)
            ) {
                continue;
            }

            // Suchstring muss dem anfang der Bez oder Nr entsprechen
         	if (lagerort.lgrortBez.toLowerCase().indexOf(suchTextLagerVon.toLowerCase()) === 0 ||
                lagerort.lgrortNr.toLowerCase().indexOf(suchTextLagerVon.toLowerCase()) === 0){

                eindeutigeLagerorte.push(lagerort);
                gefundeneIds.push(lagerort.lgrortId);
			}
        }
		return eindeutigeLagerorte;
	}

    sucheZielLager(suchTextLagerZiel){
        return _.filter(this.locations, (obj) => {
            return (obj.bez.toLowerCase().indexOf(suchTextLagerZiel.toLowerCase()) === 0 || obj.nr.toLowerCase().indexOf(suchTextLagerZiel.toLowerCase()) === 0);
        });
    }

    sucheCharge(suchTextCharge){
        let eindeutigeLagerorte = [];
        let gefundeneIds = [];
        let i;
        for(i = 0; i < this.artikel.lagerorte.length; i++) {
            let lagerort = this.artikel.lagerorte[i];

            // nicht eindeutig - überspringen.
            if (gefundeneIds.indexOf(lagerort.chargeSNrId) !== -1){
                continue;
            }

            if (
                !(this.gewaehlterQuellLagerOrt === null ||
                    typeof this.gewaehlterQuellLagerOrt === 'undefined' ||
                    typeof this.gewaehlterQuellLagerOrt.lgrortId === 'undefined' ||
                    this.gewaehlterQuellLagerOrt.lgrortId === lagerort.lgrortId)
            ) {
                continue;
            }

            // Suchstring muss dem anfang der Bez oder Nr entsprechen
            if (lagerort.chargeSNr.toLowerCase().indexOf(suchTextCharge.toLowerCase()) === 0){

                eindeutigeLagerorte.push(lagerort);
                gefundeneIds.push(lagerort.chargeSNrId);
            }
        }
        return eindeutigeLagerorte;
	}

    pruefeUndFuelleMengeLagerOrtUndCharge(typ){
		let i;

		if (this.gewaehlterQuellLagerOrt !== null && this.artikel.ueberwachungsgradArtikel !== 'UWCharge'){
			this.artikelMenge = this.gewaehlterQuellLagerOrt.lagerbestand;
			return;
		}

		if (this.gewaehlterQuellLagerOrt !== null && this.gewaehlteCharge !== null){
			for(i = 0; i < this.artikel.lagerorte.length; i++) {
				let lagerort = this.artikel.lagerorte[i];

				if (this.gewaehlterQuellLagerOrt.lgrortId === lagerort.lgrortId &&
				 	this.gewaehlteCharge.chargeSNrId === lagerort.chargeSNrId){
					//console.log('1 treffer in pruefe');
					this.artikelMenge = lagerort.lagerbestand;
				}
			}
		}
		else{
			this.artikelMenge = '';
		}
	}

    artikelUmbuchen(){
        const request = this.TransferOrderService.createArtikelUmbuchenObject(
        	this.artikel,
			this.artikelMenge,
			this.gewaehlterQuellLagerOrt,
			this.gewaehlteCharge,
			this.gewaehlterZielLagerOrt
		);
        this.TransferOrderService.artikelUmbuchen(request)
            .then((response) => {
                this.ToastService.toast('Artikel wurde erfolgreich umgebucht.');
                this.initView();
            });
	}

	/**
	 * static method to check if the user is authenticated
	 * @param {function} - $injector to inject all services
	 * @param {string} [path="Login"] - the path to navigate to if the user is not authenticated
	 * @return {promise} with true/false
	 **/
	static $canActivate($injector, path = 'Login') {
		const $rootRouter = $injector.get('$rootRouter');
		const AuthService = $injector.get('AuthService');
		const ToastService = $injector.get('ToastService');

		return AuthService.isAuthenticated().then((response) => {
			if (response) {
				return response;
			}
			$rootRouter.navigate([path]);
			ToastService.danger('Zugriff verweigert. Bitte melden Sie sich an.');
			return false;
		}, (err) =>  {
			$rootRouter.navigate([path]);
			return false;
		});
	}

}
